import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'shared-quarantined-info-panel',
  templateUrl: './quarantined-info-panel.component.html',
  styleUrl: './quarantined-info-panel.component.scss',
  standalone: false,
})
export class QuarantinedInfoPanelComponent {
  @Input() message: string;
  @Input() displayButtons = false;
  @Output() eventSubmit = new EventEmitter<'remove' | 'extend'>();
}
